import { createFileRoute } from "@tanstack/react-router";
import { NotFoundPage } from "@/features/error-pages/components/NotFoundPage";

export const Route = createFileRoute("/not-found")({
  component: NotFoundPage,
});
